module.exports = __webpack_public_path__ + "img/Estetica.1dd495d9.png";